module.exports = __webpack_public_path__ + "img/sz.6e224dc9.svg";